exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#codigo{\r\n    color: dodgerblue\r\n}\r\n#codigo :hover{\r\n    color: white;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/articulo-buscar/articulo-buscar.component.css
// module id = ../../../../../src/app/components/articulo-buscar/articulo-buscar.component.css
// module chunks = main